import { Module } from 'vuex';
import actions from './actions';

export const mailerStore: Module<any, any> = {
  namespaced: true,
  actions
};
